import React from "react";
import {
  SummarySection,
  InfoRow,
  InfoLabel,
  InfoValue,
} from "./SummaryResponseDisplay.styles";

export const SummaryResponseDisplay = ({ data, t }) => {
  return (
    <SummarySection>
      <InfoRow>
        <InfoLabel>{t("logs.language")}:</InfoLabel>
        <InfoValue>{data.language}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>{t("logs.summary")}:</InfoLabel>
        <InfoValue>{data.summary}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>{t("logs.currentQuestion")}:</InfoLabel>
        <InfoValue>{data.currentQuestion}</InfoValue>
      </InfoRow>
    </SummarySection>
  );
};
